import * as React from 'react';
import * as main from "../../main.module.scss";
import { Modal } from "../../../../Modal";
export const Points = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={main.hugs}>
      <div className="container">
        <div className={`${main.container} ${main.violet}`}>
          <ul className={main.listTriple}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/talk-01.png" alt=""/>
              <p>Обсудим как развить память как у супергероя, чтобы легко запоминать любые формулы, даты, определения, стихи и другие данные</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/talk-02.png" alt=""/>
              <p>Как развить скорочтение, чтобы не тратить время на скучную домашку</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/talk-03.png" alt=""/>
              <p>Как научиться планировать и делать все быстро, чтобы было больше времени на отдых, игры, спорт, творчество и друзей</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/talk-04.png" alt=""/>
              <p>Расскажем, как закончить школу экстерном без рисков что-то не понять и упустить</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/talk-05.png" alt=""/>
              <p>Обсудим подготовку к ОГЭ и ЕГЭ. Как перестать их бояться и научиться писать за час-полтора</p>
            </li>
          </ul>
          <div className={main.centeredBtnBlock}>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться бесплатно</button>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
